import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "v-text-subtitle1" }
const _hoisted_4 = { href: "mailto:board.customercare@bmwgroup.com" }
const _hoisted_5 = { class: "d-flex align-center" }

export function render(_ctx, _cache) {
  const _component_DynamicTitle = _resolveComponent("DynamicTitle")
  const _component_v_chip = _resolveComponent("v-chip")
  const _component_router_link = _resolveComponent("router-link")
  const _component_v_data_table = _resolveComponent("v-data-table")
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_v_alert = _resolveComponent("v-alert")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_SideFilter = _resolveComponent("SideFilter")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DynamicTitle, {
        elements: [{ name: 'Daily Cases', selected: true }],
        title: "reporting"
      }),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createTextVNode(" Daily report: ", -1)),
        _createVNode(_component_v_chip, {
          variant: "flat",
          color: "blue-lighten-5",
          class: "text-indigo ml-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.value), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_v_data_table, {
        id: "daily-table",
        headers: _ctx.headers,
        items: _ctx.items
      }, {
        "item.internalId": _withCtx(({ item }) => [
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              to: _ctx.caseEditRoute + item.caseId
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.internalId), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ])
        ]),
        "item.authorOfConcern": _withCtx(({ item }) => [
          _createElementVNode("div", null, _toDisplayString(item.authorOfConcern), 1)
        ]),
        "item.repeatConcern": _withCtx(({ item }) => [
          _createElementVNode("div", null, _toDisplayString(item.repeatConcern ? "Yes" : "No"), 1)
        ]),
        "item.recipient": _withCtx(({ item }) => [
          _createElementVNode("div", null, _toDisplayString(item.recipient), 1)
        ]),
        "item.market": _withCtx(({ item }) => [
          _createElementVNode("div", null, _toDisplayString(item.market), 1)
        ]),
        "item.brand": _withCtx(({ item }) => [
          _createElementVNode("div", null, _toDisplayString(item.brand), 1)
        ]),
        "item.model": _withCtx(({ item }) => [
          _createElementVNode("div", null, _toDisplayString(item.model), 1)
        ]),
        "item.theme": _withCtx(({ item }) => [
          _createElementVNode("div", null, _toDisplayString(item.theme), 1)
        ]),
        "item.keyIssueGerman": _withCtx(({ item }) => [
          _createElementVNode("div", null, _toDisplayString(item.keyIssueGerman), 1)
        ]),
        "item.keyIssueInternational": _withCtx(({ item }) => [
          _createElementVNode("div", null, _toDisplayString(item.keyIssueInternational), 1)
        ]),
        _: 1
      }, 8, ["headers", "items"]),
      _createVNode(_component_v_alert, {
        border: "start",
        density: "compact",
        variant: "text",
        type: "info"
      }, {
        default: _withCtx(() => [
          _cache[4] || (_cache[4] = _createTextVNode(" If you have any questions, please contact Complaint Management CA-12 ", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("a", _hoisted_4, [
            _createVNode(_component_v_icon, { color: "blue" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-email", -1)
              ]))]),
              _: 1
            }),
            _cache[3] || (_cache[3] = _createTextVNode(" board.customercare@bmwgroup.com ", -1))
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_SideFilter, { class: "filter" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_date_picker, {
          modelValue: _ctx.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
          class: "mt-2 mb-4",
          "first-day-of-week": "1",
          width: "400"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_btn, {
            class: "me-2",
            color: "warning",
            onClick: _ctx.applyFilter
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("mdi-filter", -1)
                ]))]),
                _: 1
              }),
              _cache[7] || (_cache[7] = _createTextVNode(" Apply filters ", -1))
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_btn, {
            class: "me-2",
            color: "grey",
            onClick: _ctx.resetToDefault
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { color: "white" }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-cog", -1)
                ]))]),
                _: 1
              }),
              _cache[9] || (_cache[9] = _createTextVNode(" Reset to default ", -1))
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("div", null, [
            _createVNode(_component_v_btn, {
              variant: "plain",
              icon: "mdi-tray-arrow-down",
              size: "large",
              onClick: _ctx.downloadPdfReport
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}